import { useLocalSearchParams } from 'expo-router';

import IncomeSplitConfirmation from '../../../banking/components/income-split/IncomeSplitConfirmation';
import type { IncomeSplitContext } from '../../../banking/types/IncomeSplit';

export default function PaycheckRoutingConfirmation() {
    const { isEdit, context } = useLocalSearchParams<{
        isEdit: string;
        context: IncomeSplitContext;
    }>();

    return (
        <IncomeSplitConfirmation
            isEdit={isEdit === 'true'}
            context={context ?? 'incomeSplit'}
        />
    );
}
